export default {
  getRoutes(state) {
    return state.routes;
  },
  getCurrentRoute(state) {
    return (
      state.currentRoute || {
        routeId: 0,
        routeName: "",
        operators: [],
        areas: [],
        products: [],
        sortedOrder: [],
        deletedContainers: [],
      }
    );
  },
  getFilteredSites(state) {
    const sites = state.filteredSites;
    for (const key in sites) {
      for (const propKey in sites[key].containerProperties) {
        sites[key][propKey] = sites[key].containerProperties[propKey];
      }
    }
    return sites;
  },
  getResponseCode(state) {
    return state.responseCode;
  },
  getRouteConfig(state) {
    return state.routeConfig;
  },
};
